import React from 'react';
import ReactDOM from 'react-dom';
import { Modal, SageClassnames } from '@kajabi/sage-react';

import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import Loader from 'common/components/CopyMagic/components/Loader';
import ErrorMessage from 'common/components/CopyMagic/components/ErrorMessage';
import CloseButton from 'common/components/CopyMagic/components/CloseButton';

import FooterActions from './components/FooterActions';
import PromptForm from './components/PromptForm';
import ResultDisplay from './components/ResultDisplay';

const CourseOutline = () => {
  const { open } = useUiResourceContext();

  if (!open) return null;

  return ReactDOM.createPortal(
    <Modal size={Modal.SIZES.MD} active allowScroll className="copy-magic-modal">
      <Modal.Header title="✨ Course generator" aside={<CloseButton />}>
        <div className={SageClassnames.SPACERS.MD_TOP}>
          <PromptForm />
        </div>
      </Modal.Header>
      <Loader />
      <ErrorMessage />
      <ResultDisplay />
      <FooterActions />
    </Modal>,
    document.body,
  );
};

export default CourseOutline;
